import { storeAsync } from '@/app-module';
import { routerAsync } from '../../../app-module';

export default {
    async beforeRouteEnter(to, from, next) {
        // Skip auth check if route doesn't require authentication
        if (!to.meta || !to.meta.auth) {
            next();
            return;
        }

        const store = storeAsync();
        await store.dispatch('auth/doWaitUntilInit');

        // Organization-specific route check
        if (to.meta.authOrg) {
            const currentUserOrganisationId = store.getters['auth/currentUserOrganisationId'];
            if (to.query.id !== currentUserOrganisationId) {
                next({ path: '/home', replace: true });
                return;
            }
        }

        // Authentication check - don't redirect if already on auth/signin
        if (!store.getters['auth/isAuthenticated'] &&
            !store.getters['auth/isAuthSucceeded']
        ) {
            if (from.path !== '/auth/signin') {
                // Preserve the intended destination (e.g. a PCUEL "Detalii" deep link
                // to /application/:id) so the user is returned there after signing in,
                // instead of always landing on the dashboard.
                const returnUrl = to.fullPath.replace(/^\//, '');
                next({ path: '/auth/signin', query: { returnUrl }, replace: true });
                return;
            }
            next();
            return;
        }

        // Email confirmation check
        if (
            to.path !== '/auth/confirm-email' &&
            !store.getters['auth/isEmailConfirmed']
        ) {
            next({ path: '/auth/confirm-email', replace: true });
            return;
        }

        // Phone verification check
        if (to.path !== '/auth/verify-sms' &&
            store.getters['auth/isEmailConfirmed'] &&
            !store.getters['auth/isPhoneConfirmed']
        ) {
            next({ path: '/auth/verify-sms', replace: true });
            return;
        }

        next();
    }
};
